import './index.css'

import * as serviceWorker from './serviceWorker'

import App, { Providers } from './App'

import React from 'react'
import ReactDOM from 'react-dom'
import { PostHogProvider } from 'posthog-js/react'
import { LicenseInfo } from '@material-ui/x-grid'
import { ENVIRONMENT, POSTHOG_KEY, POSTHOG_PROXY_ENDPOINT } from './env'

LicenseInfo.setLicenseKey(
  '8fef834ac094057799e038823118d084T1JERVI6MjAwNzQsRVhQSVJZPTE2NDE5NjMwMjkwMDAsS0VZVkVSU0lPTj0x'
)

const SERVICE_NAME = 'superadmin'

// "production" covers both "production" and "prod"; every other value
// (staging, dev, empty) is reported as "staging".
const NORMALIZED_ENVIRONMENT = ENVIRONMENT === 'production' || ENVIRONMENT === 'prod' ? 'production' : 'staging'

ReactDOM.render(
  <Providers>
    <PostHogProvider
      apiKey={POSTHOG_KEY || ''}
      options={{
        api_host: POSTHOG_PROXY_ENDPOINT,
        capture_exceptions: true,
        loaded: client =>
          client.register({
            service: SERVICE_NAME,
            environment: NORMALIZED_ENVIRONMENT
          })
      }}>
      <App />
    </PostHogProvider>
  </Providers>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
